import {
  mountRpgRuntime,
  type MountedRpgRuntime,
} from "@h5-rpg/runtime-melon";

import type { V1GameEngine } from "../v1/engine";
import { V1GameSurface, type V1AtlasSet } from "../v1/surface";

export type MountedGameRuntime = MountedRpgRuntime<V1GameSurface>;

const loadImage = (source: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.decoding = "async";
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`素材载入失败：${source}`));
    image.src = source;
  });

export const mountGameRuntime = async (
  target: HTMLElement,
  engine: V1GameEngine,
): Promise<MountedGameRuntime> => {
  const [actors, combatEffects, equipment, items, monsters, portals, skills, tiles] =
    await Promise.all([
      loadImage("/assets/characters-monsters-atlas.webp"),
      Promise.all([1, 2].map((index) =>
        loadImage(`/assets/combat-effects-0${index}.webp`),
      )),
      loadImage("/assets/equipment-atlas.webp"),
      loadImage("/assets/items-icons-8x8.webp"),
      Promise.all([1, 2, 3, 4].map((index) =>
        loadImage(`/assets/monsters-atlas-0${index}.webp`),
      )),
      loadImage("/assets/portals-atlas.webp"),
      Promise.all([1, 2].map((index) =>
        loadImage(`/assets/skills-icons-0${index}.webp`),
      )),
      loadImage("/assets/tiles-atlas.webp"),
    ]);
  const atlases: V1AtlasSet = {
    actors,
    combatEffects,
    equipment,
    items,
    monsters,
    portals,
    skills,
    tiles,
  };
  return mountRpgRuntime({
    target,
    desktopSize: { width: 1180, height: 720 },
    portraitSize: { width: 430, height: 900 },
    ariaLabel: "烬途 H5 RPG 游戏画布",
    backgroundColor: "#0b090d",
    createSurface: (width, height) => {
      const surface = new V1GameSurface(engine, width, height, atlases);
      surface.name = "jintu-game-surface";
      return surface;
    },
  });
};
